import type { Store } from "redux";
import { connect } from "react-redux";
import Footer from "storefront/components/Page/Footer";
import type { UserSelf } from "storefront/User";
import createApp from "../../containers/home";
import type { State } from "../../types/State";

type StateProps = {
  currentUser: UserSelf;
};

const mapStateToProps: (arg0: State) => StateProps = (state) => ({
  currentUser: state.session.currentUser,
});

const render = (footerDOMNode: HTMLElement, store: Store) =>
  createApp(footerDOMNode, connect(mapStateToProps)(Footer), store);

export default render;
